import React, { useState, useEffect } from 'react';

import CustomSelect from '../../modules/custom-select/CustomSelect';

const PackagesTable = ({ packages, creators, reviewers, technicalReviewers, watchers, savePackages }) => {

    const [formValues, setFormValues] = useState(packages.map(pkg => ({
        ...pkg,
        creatorId: -1,
        reviewerId: -1,
        technicalReviewerId: -1,
        watcherId: -1,
        questionCount: 0
    })));
    
    const [errors, setErrors] = useState({});
     // Form doğrulama fonksiyonu
    const validateForm = (values) => {
        let newErrors = {};
        values.forEach((pkg, idx) => {
            let pkgErrors = {};
            if (!pkg.creatorId) {
                pkgErrors.creatorId = 'Yazar seçimi zorunludur';
            }
            if (!pkg.reviewerId) {
                pkgErrors.reviewerId = 'Teknik Kontrolcü seçimi zorunludur';
            }
            if (!pkg.watcherId) {
                pkgErrors.reviewerId = 'Takip kullanıcısı seçimi zorunludur';
            }
            if (pkg.questionCount <= 0) {
                pkgErrors.questionCount = 'Soru sayısı 0 veya daha az olamaz';
            }
            if (Object.keys(pkgErrors).length > 0) {
                newErrors[idx] = pkgErrors;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSelectChange = (index, field, value) => {
        const newFormValues = [...formValues];
        newFormValues[index][field] = value;
        setFormValues(newFormValues);
    };

    // Tüm paketler için kaydetme işlemi
    const handleSubmit = async () => {
        if (!validateForm(formValues)) {
            alert('Form hataları var, lütfen düzeltin!');
            return;
        }
        console.log("Kaydedilen değerler: ", formValues);
        savePackages(formValues);
    };

    useEffect(() => {
        setFormValues(packages.map(pkg => ({
        ...pkg,
        creatorId: -1,
            reviewerId: -1,
            technicalReviewerId: -1,
            watcherId: -1,
        questionCount: 0
    })))
    }, [packages]);

    return (
        <div>
            <h1>Paket Tanımlama</h1>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>GUID</th>
                        <th>Paket Adı</th>
                        <th>Yazar</th>
                        <th>Teknik Kontrolcü</th>
                        <th>Takip Eden Kullanıcı</th>
                        <th>Soru Sayısı</th>
                    </tr>
                </thead>
                <tbody>
                    {formValues.map((pkg, index) => (
                        <tr key={index}>
                            <td>{pkg.guid}</td>
                            <td>{pkg.name}</td>
                            <td>
                                <CustomSelect
                                    options={creators.map(creator => ({ value: creator.id, label: creator.name + ' ' + creator.surName }))}
                                    onChange={(selectedOption) => handleSelectChange(index, 'creatorId', selectedOption.value)}
                                    value={creators.find(creator => creator.id === pkg.creatorId) ? { value: pkg.creatorId, label: creators.find(creator => creator.id === pkg.creatorId).name } : null}
                                    isSearchable={true}
                                    error={errors[index]?.creatorId}
                                />
                            </td>
                            <td>
                                <CustomSelect
                                    options={reviewers.map(reviewer => ({ value: reviewer.id, label: reviewer.name + ' ' + reviewer.surName }))}
                                    onChange={(selectedOption) => handleSelectChange(index, 'reviewerId', selectedOption.value)}
                                    value={reviewers.find(reviewer => reviewer.id === pkg.reviewerId) ? { value: pkg.reviewerId, label: reviewers.find(reviewer => reviewer.id === pkg.reviewerId).name } : null}
                                    isSearchable={true}
                                    error={errors[index]?.reviewerId}
                                />
                            </td>
                            {/*<td>*/}
                            {/*    <CustomSelect*/}
                            {/*        options={technicalReviewers.map(reviewer => ({ value: reviewer.id, label: reviewer.name }))}*/}
                            {/*        onChange={(selectedOption) => handleSelectChange(index, 'technicalReviewerId', selectedOption.value)}*/}
                            {/*        value={technicalReviewers.find(reviewer => reviewer.id === pkg.technicalReviewerId) ? { value: pkg.technicalReviewerId, label: technicalReviewers.find(reviewer => reviewer.id === pkg.technicalReviewerId).name } : null}*/}
                            {/*        isSearchable={true}*/}
                            {/*        error={errors[index]?.technicalReviewerId}*/}
                            {/*    />*/}
                            {/*</td>*/}
                            <td>
                                <CustomSelect
                                    options={watchers.map(watcher => ({ value: watcher.id, label: watcher.name + ' ' + watcher.surName }))}
                                    onChange={(selectedOption) => handleSelectChange(index, 'watcherId', selectedOption.value)}
                                    value={watchers.find(watcher => watcher.id === pkg.watcherId) ? { value: pkg.watcherId, label: watchers.find(watcher => watcher.id === pkg.watcherId).name } : null}
                                    isSearchable={true}
                                    error={errors[index]?.watcherId}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={pkg.questionCount}
                                    onChange={(e) => handleSelectChange(index, 'questionCount', e.target.value)}
                                />
                                {errors[index]?.questionCount && (
                                    <div className="invalid-feedback">
                                        {errors[index].questionCount}
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table><button onClick={handleSubmit} className="btn btn-primary mt-3">Tümünü Kaydet</button>
       
        </div>
    );
};

export default PackagesTable;
